import Paper from "@mui/material/Paper";
import type { ReactNode } from "react";
import { pageSectionPanelSx } from "../../lib/ui/formLayout";

type Props = {
  children: ReactNode;
};

/** Outlined section panel for form blocks (upload, settings groups). */
export default function PageSectionPanel({ children }: Props) {
  return (
    <Paper variant="outlined" sx={pageSectionPanelSx}>
      {children}
    </Paper>
  );
}
